module.exports = __webpack_public_path__ + "img/knue_gallery5.f0c29fc0.jpg";